import { Route, Routes } from "react-router-dom";
import { ProvideMedals } from "./hooks/useMedals";
import { MedalTable } from "./components/MedalTable";
import { MedalPodium } from "./components/MedalPodium";
import { Landing } from "./components/Landing";
import { useParams } from 'react-router-dom';

export const App = () => {

  const MedalTableWrapper = () => {
    const { type, language, size, defaultSort } = useParams();
  
    return (
      <MedalTable
        defaultSort={defaultSort || "gold"}
        type={type || "standard"}
        language={language || "fr"}
        size={size || "long"}
        tableWidth={286}
        tableHeight={500}
      />
    );
  };

  const MedalPodiumWrapper = () => {
    const { language } = useParams();
  
    return (
      <MedalPodium
        language={language || "en"}
        tableWidth={286}
      />
    );
  };

  return (
    <ProvideMedals>
      <Routes>
        <Route path="/table/:type/:language/:size/:defaultSort" element={<MedalTableWrapper />} />
        <Route path="/podium/:language" element={<MedalPodiumWrapper />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </ProvideMedals>
  );
};